const currencyFormatter = new Intl.NumberFormat('pt-BR', {
  style: 'currency',
  currency: 'BRL',
  minimumFractionDigits: 2,
});

export const formatCurrency = (value) => currencyFormatter.format(value ?? 0);

// A listagem mostra apenas dia/mês, já que o período é definido pelo filtro.
export const formatShortDate = (date) => (date ? date.slice(0, 5) : '');
